const AddressDetails = ({ currentAddress, permanentAddress }) => (
  <div>
    <p style={{ textAlign: 'center' }}>Address Details</p>
    <div className="address-table">
      <table style={{ width: '100%' }}>
        <thead style={{ textAlign: 'center' }}>
          <tr>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Current Address</th>
            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Permanent Address</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ textAlign: 'center' }}>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              {currentAddress}
            </td>
            <td style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
              {permanentAddress}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default AddressDetails;